import { styled } from "styled-components";

import { Card } from "../invoiceCard/style";

export const SidebarCard = styled(Card)`
  width: 38rem;
  height: calc(100vh - 260px);
  min-height: 38rem;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const InvoicesSection = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0; /* Importante para que o flex funcione corretamente com scroll */
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const InvoiceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: visible; /* Permite que o conteúdo seja visível com scroll */
`;

export const EmptyInvoiceList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding-top: 50px;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 8px;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;

  div {
    font-size: 14px;
    color: #6b7280;
    font-weight: 500;
  }
`;
